export default __webpack_public_path__ + "static/media/fundo-apresentacao.97861547.png";